import { render, staticRenderFns } from "./GeneralSettingsTaxes.vue?vue&type=template&id=e37ed9c6&"
import script from "./GeneralSettingsTaxes.vue?vue&type=script&lang=ts&"
export * from "./GeneralSettingsTaxes.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports